<template>
    <div class="position-relative">
        <NuxtLinkLocale class="nav-link nav-cart has-dark"
           to="checkout"
           rel="nofollow"
           :title="$t('View cart')">
            {{$t('Cart')}}
        </NuxtLinkLocale>
        <span
            v-if="count > 0"
            :class="{'plus-100': count > 100}"
            class="badge top-badge rounded-pill position-absolute top-0 start-100 translate-middle">
            {{ count > 100000 ? '9999+' : count }}
        </span>
    </div>
</template>

<script setup>
import {useCartStore} from "~/stores/CartStore";

const cartStore = useCartStore();
const checkoutStore = useCheckoutStore();


const count = computed(() => checkoutStore.bundling ? checkoutStore.bundledInvoices.length : cartStore.count);

</script>
